import PropTypes from 'prop-types';
import React from 'react';
import LazyRender from '../LazyRender/index.js';

/**
 *  The Image component will render a sourced image to the DOM.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function Image(_ref) {
  let {
    lazyload = true,
    loading = 'lazy',
    alt = '',
    isResponsive = false,
    ...rest
  } = _ref;
  let component = 'img';
  let props;
  let children = null;
  rest.loading = loading;
  if (lazyload) {
    component = LazyRender;
    props = {
      height: rest.height,
      width: rest.width,
      threshold: 600
    };

    // avoid add empty class atribute
    if (isResponsive) {
      props.className = 'img-responsive';
    }
    children = /*#__PURE__*/_jsx("img", {
      alt: alt,
      ...rest
    });
  } else {
    props = {
      ...rest,
      alt
    };
    if (loading === 'eager' && props.fetchpriority === undefined) {
      props.fetchpriority = 'high';
    }
  }
  return /*#__PURE__*/React.createElement(component, props, children);
}
export default Image;